import { VerificationStepsEnum } from "../types/runtimeTypes";
import { CollectFieldsResponse, DatabaseId, VerificationStep, ViewModel } from "../types/types";
import { getFieldsToCollectUrl } from "./ApiUrls";
import * as Network from "./Network";
import { stepToRequest } from "./StepToRequest";

/**
 * EXPERIMENTAL - Check which fields are required and optional for a given view model
 */
export async function getFieldsToCollect(
  verificationId: DatabaseId,
  step: VerificationStep,
  viewModel: ViewModel,
): Promise<CollectFieldsResponse> {
  if (VerificationStepsEnum[step]) {
    const requestBody = stepToRequest[step](viewModel);
    const response = (await Network.PostJson(
      getFieldsToCollectUrl(verificationId, step),
      requestBody,
    )) as CollectFieldsResponse;
    if (response.currentStep === "error") {
      throw new Error(`Failed to determine fields to collect: ${response}`);
    }
    return response as CollectFieldsResponse;
  }
  throw new Error(`Unknown step ${step}`);
}
